import { useState } from "react"

export type FuriganaMode = "all" | "unknown" | "none"

const MODE_KEY = "furigana-mode"
const FIRST_ONLY_KEY = "furigana-first-only"

const readMode = (): FuriganaMode => {
  const stored = localStorage.getItem(MODE_KEY)
  if (stored === "all" || stored === "unknown" || stored === "none")
    return stored
  return "all"
}

const readFirstOnly = (): boolean =>
  localStorage.getItem(FIRST_ONLY_KEY) === "true"

export function useFuriganaPreference() {
  const [mode, setModeState] = useState<FuriganaMode>(readMode)
  const [firstOnly, setFirstOnlyState] = useState<boolean>(readFirstOnly)

  const setMode = (next: FuriganaMode) => {
    localStorage.setItem(MODE_KEY, next)
    setModeState(next)
  }

  const setFirstOnly = (next: boolean) => {
    localStorage.setItem(FIRST_ONLY_KEY, String(next))
    setFirstOnlyState(next)
  }

  return { mode, setMode, firstOnly, setFirstOnly }
}
